// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"bccfe35d","453":"12f5ac3a","846":"21fdca7a"}[chunkId] + ".chunk.js";
};